// material ui icons
import ConstructionIcon from '@mui/icons-material/Construction';

// material ui
import { Alert, Box } from '@mui/material';

/**
 * UpdateBanner - A persistent banner showing system update status
 * @param {Object} props
 * @param {string} props.message - Optional custom message to display
 */
const UpdateBanner = ({ message }) => {
  return (
    <Box
      sx={{
        width: '100%',
        borderBottom: 1,
        borderColor: 'divider',
      }}
    >
      <Alert
        severity="info"
        icon={<ConstructionIcon />}
        sx={{
          borderRadius: 0,
          '& .MuiAlert-message': {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
          },
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box>
            {message && (
              <Box component="span" sx={{ fontSize: '0.875rem' }}>
                {message}
              </Box>
            )}
          </Box>
        </Box>
      </Alert>
    </Box>
  );
};

export default UpdateBanner;
